export enum ExchangeName {
  BIGONE = 'bigone',
  BYBIT = 'bybit',
  GATE = 'gate',
  HTX = 'htx',
  HYPERLIQUID = 'hyperliquid',
  MEXC = 'mexc',
  PANCAKESWAP = 'pancakeswap',
  XT = 'xt',
}
